function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "cactus");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.871911282,5.1 L179.328089,5.1 L179.572087,8.53459352 C180.420575,20.8496162 180.528422,30.109017 172.215493,36.5680221 C170.73027,62.2362707 167.382229,84.8803614 159.835496,102.825118 C136.982914,107.240925 112.776495,109.613586 87.7172938,109.613586 C63.8723156,109.613586 40.7994798,107.465285 18.9321272,103.450282 C11.0423498,85.0495128 7.65319107,61.6241711 6.19700454,35.0161904 C-0.948320825,28.0265149 -0.0599963886,18.143885 0.871911282,5.1 Z",
  id: "Path",
  fill: "#FF9479"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M179.328089,5.1 L179.572087,8.53459352 C180.420575,20.8496162 180.528422,30.109017 172.215493,36.5680221 C170.73027,62.2362707 167.382229,84.8803614 159.835496,102.825118 C149.004949,104.917906 137.870315,106.551782 126.484933,107.691668 C117.535983,66.4647535 102.755764,72.4563877 79.4034019,44.307414 C66.3857039,28.6158603 70.6222349,15.1111201 82.2837775,5.09991392 L179.328089,5.1 Z",
  id: "Combined-Shape",
  fill: "#FB8175"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M179.328089,5.1 C180.645128,23.5345569 181.875116,35.65502 160.462265,42.2109627 C138.901377,45.6911054 115.458069,47.6 90.9435818,47.6 C65.1076973,47.6 40.4615842,45.4797699 17.9548308,41.6345471 C-1.60466074,34.9562758 -0.407444911,23.0071121 0.871911282,5.1 L179.328089,5.1 Z",
  id: "Path",
  fill: "#FF7559"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M179.328089,5.1 C180.645128,23.5345569 181.875116,35.65502 160.462265,42.2109627 C138.901377,45.6911054 115.458069,47.6 90.9435818,47.6 C87.9993244,47.6 85.0705183,47.5724648 82.1585691,47.5179794 C81.2539726,46.5001638 80.335516,45.4309857 79.4034019,44.307414 C66.3857039,28.6158603 70.6222349,15.1111201 82.2837775,5.09991392 L179.328089,5.1 Z",
  id: "Combined-Shape",
  fill: "#F75954"
});

var _ref8 =
/*#__PURE__*/
React.createElement("ellipse", {
  id: "Oval",
  fill: "#13263C",
  cx: 90.1,
  cy: 5.1,
  rx: 88.4,
  ry: 5.1
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M96.5126417,3.0009378 C113.008051,3.06132927 126.371504,6.03099579 126.978468,9.73665542 C116.169988,10.0229868 104.187648,10.1875067 91.5618556,10.1993167 L88.6381444,10.1993167 C80.4388938,10.1916472 72.5110041,10.1195759 64.9998308,9.99148872 C65.0215386,6.12914552 78.8924562,3 96,3 Z",
  id: "Combined-Shape",
  fill: "#189E8D"
});

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group-6",
  transform: "translate(32.000000, 163.000000)",
  fill: "#2F3344"
}, React.createElement("ellipse", {
  id: "Oval-5",
  cx: 7.20382166,
  cy: 7.20472441,
  rx: 7.20382166,
  ry: 7.20472441
}), React.createElement("ellipse", {
  id: "Oval-5",
  cx: 69.0382166,
  cy: 7.20472441,
  rx: 7.20382166,
  ry: 7.20472441
}), React.createElement("path", {
  d: "M25.0949045,20.8937008 C25.0949045,27.2601959 30.2553218,32.4212598 36.6210191,32.4212598 L36.6210191,32.4212598 C42.9867165,32.4212598 48.1471338,27.2601959 48.1471338,20.8937008",
  id: "Oval-5"
}));

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  id: "plant",
  transform: "translate(8.500000, 0.000000)"
}, React.createElement("circle", {
  id: "Oval-7-Copy-4",
  fill: "#41CC99",
  cx: 28.9,
  cy: 34,
  r: 27.2
}), React.createElement("path", {
  d: "M55.2430606,27.1999203 C55.8024723,29.3733598 56.1,31.6519342 56.1,34 C56.1,49.0221452 43.9221452,61.2 28.9,61.2 C13.8778548,61.2 1.7,49.0221452 1.7,34 C1.7,31.6519342 1.99752769,29.3733598 2.55693941,27.1999203 C5.57684085,38.9318958 16.2261483,47.6 28.9,47.6 C41.518602,47.6 52.1302726,39.0073056 55.202971,27.3539579 Z",
  id: "Combined-Shape",
  fill: "#2DB799"
}), React.createElement("circle", {
  id: "Oval-7",
  fill: "#38C290",
  cx: 73.95,
  cy: 68.85,
  r: 50.15
}), React.createElement("path", {
  d: "M107.632532,31.6942885 C117.747619,40.8693984 124.1,54.1178602 124.1,68.85 C124.1,96.5470802 101.64708,119 73.95,119 C52.1288179,119 33.5627374,105.063254 26.6673066,85.6053094 C35.5693638,93.6802875 47.3851517,98.6 60.35,98.6 C88.0470802,98.6 110.5,76.1470802 110.5,48.45 C110.5,42.6336132 109.509826,37.0484938 107.688849,31.8540122 Z",
  id: "Combined-Shape",
  fill: "#189E8D"
}), React.createElement("circle", {
  id: "Oval-7-Copy",
  fill: "#41CC99",
  cx: 110.5,
  cy: 83.3,
  r: 35.7
}), React.createElement("path", {
  d: "M133.898646,56.336461 C141.43483,62.8819041 146.2,72.5344695 146.2,83.3 C146.2,103.016566 130.216566,119 110.5,119 C101.934248,119 94.0730938,115.983255 87.9210377,110.954264 C91.2868022,111.894921 94.8351046,112.398126 98.500937,112.398126 C120.149982,112.398126 137.7,94.8481077 137.7,73.199063 C137.7,67.3538209 136.420604,61.8073979 134.126567,56.8245497 Z",
  id: "Combined-Shape",
  fill: "#1FA99C"
}), React.createElement("circle", {
  id: "Oval-7-Copy-3",
  fill: "#5FCF9F",
  cx: 97.75,
  cy: 19.55,
  r: 14.45
}), React.createElement("path", {
  d: "M111.068657,13.935372 C111.797209,15.6614843 112.2,17.5587037 112.2,19.55 C112.2,27.5305146 105.730515,34 97.75,34 C92.7226388,34 88.2949185,31.432632 85.7064176,27.5374746 C88.1288096,28.8235746 90.8924483,29.5528252 93.8264126,29.5528252 C102.743086,29.5528252 110.086589,22.8172777 111.046524,14.1565787 Z",
  id: "Combined-Shape",
  fill: "#35B49C"
}), React.createElement("line", {
  x1: 101.15,
  y1: 5.95,
  x2: 102,
  y2: 0,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 87.55,
  y1: 12.75,
  x2: 85,
  y2: 8.5,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 9.35,
  y1: 17.85,
  x2: 6.8,
  y2: 15.3,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 22.1,
  y1: 17,
  x2: 20.4,
  y2: 15.3,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 39.1,
  y1: 34,
  x2: 35.7,
  y2: 30.6,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 52.7,
  y1: 25.5,
  x2: 51,
  y2: 22.1,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 28.9,
  y1: 87.125,
  x2: 25.5,
  y2: 88.4,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 25.5,
  y1: 66.725,
  x2: 22.1,
  y2: 66.725,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 3.4,
  y1: 32.725,
  x2: 0,
  y2: 32.725,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 109.65,
  y1: 14.45,
  x2: 112.2,
  y2: 11.9,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 36.55,
  y1: 7.65,
  x2: 36.55,
  y2: 5.1,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 123.25,
  y1: 51.85,
  x2: 124.1,
  y2: 45.9,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 90.95,
  y1: 55.25,
  x2: 90.1,
  y2: 52.7,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 84.15,
  y1: 60.35,
  x2: 83.3,
  y2: 59.5,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 144.5,
  y1: 85,
  x2: 147.9,
  y2: 85,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 139.4,
  y1: 100.725,
  x2: 141.1,
  y2: 102,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}), React.createElement("line", {
  x1: 140.25,
  y1: 65.45,
  x2: 146.2,
  y2: 62.9,
  id: "Line",
  stroke: "#223851",
  strokeWidth: 3.4,
  strokeLinecap: "round"
}));

var SvgCactus = function SvgCactus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "180px",
    height: "231px",
    viewBox: "0 0 180 231",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Artboard",
    transform: "translate(-773.000000, -676.000000)"
  }, React.createElement("g", {
    id: "cactus",
    transform: "translate(773.000000, 678.000000)"
  }, React.createElement("g", {
    id: "pot",
    transform: "translate(0.000000, 111.000000)"
  }, React.createElement("ellipse", {
    id: "Shadow",
    fill: "#D0DEE4",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 90.1,
    cy: 105.4,
    rx: 76.5,
    ry: 11.9
  }), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9), _ref10, _ref11))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCactus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cactus.ef557f32.svg";
export { ForwardRef as ReactComponent };